import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { routeTransition } from './animations/route-transition.animation';
import { ToastComponent } from './components/organisms/toast/toast.component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  animations: [routeTransition],
  imports: [RouterOutlet, ToastComponent],
})
export class AppComponent {
  private swUpdate = inject(SwUpdate);

  constructor() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          window.location.reload();
        }
      });
    }
  }

  prepareRoute(outlet: RouterOutlet) {
    return outlet?.activatedRouteData?.['animate'] ? 'true' : 'false';
  }
}
